/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BaseModel } from './BaseModel';
import type { GeometryCollection } from './GeometryCollection';
import type { LineString } from './LineString';
import type { MultiLineString } from './MultiLineString';
import type { MultiPoint } from './MultiPoint';
import type { MultiPolygon } from './MultiPolygon';
import type { Point } from './Point';
import type { Polygon } from './Polygon';

/**
 * Abstract base class for generic types.
 *
 * A generic type is typically declared by inheriting from
 * this class parameterized with one or more type variables.
 * For example, a generic mapping type might be defined as::
 *
 * class Mapping(Generic[KT, VT]):
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * This class can then be used as follows::
 *
 * def lookup_name(mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type eoi_client__eoi_client__models__geojson__Feature = {
    type: eoi_client__eoi_client__models__geojson__Feature.type;
    id?: (string | number);
    properties: BaseModel;
    geometry?: (Point | LineString | Polygon | MultiPoint | MultiLineString | MultiPolygon | GeometryCollection);
};

export namespace eoi_client__eoi_client__models__geojson__Feature {

    export enum type {
        FEATURE = 'Feature',
    }


}

